import * as actionTypes from "../../constants/ActionTypes/PrintActivity";

const initialState = {
    printActivity: {},
    loading: false,
    error: false,
    success: false,
}

const PrintActivity = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_PRINT_ACTIVITY_INIT:
            return {
                ...state,
                loading: true,
                error: false
            };
        case actionTypes.GET_PRINT_ACTIVITY_SUCCESS:
            return {
                ...state,
                printActivity: action.printActivity,
                loading: false,
                success: true,
                error: false,
            };
        case actionTypes.GET_PRINT_ACTIVITY_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message
            };
        case actionTypes.RESET_GET_PRINT_ACTIVITY:
            return {
                ...state,
                error: false,
                printActivity: {},
                success: false,
                loading: false
            };
        default:
            return { ...state };
    }
}

export default PrintActivity;